import { inject, Injectable } from "@angular/core";
import { CanActivate, GuardResult, MaybeAsync } from "@angular/router";
import { BootstrapService } from "src/app/modules/bootstrap/bootstrap.service";
import { RegionService } from "src/app/services/feature-access-control/region.service";

@Injectable()
export class ProvideRegionGuard implements CanActivate {
  private readonly bootstrapService = inject(BootstrapService);
  private readonly regionService = inject(RegionService);

  canActivate(): MaybeAsync<GuardResult> {
    const tenant = this.bootstrapService.getCurrentTenant()!;

    this.regionService.setByString(tenant.region);

    this.regionService.setTimezone(tenant.timezone);

    return true;
  }
}
